export default __webpack_public_path__ + "static/media/1281.05091449.jpg";